import * as React from "react";

import GreenCheckImage from "images/completed-check.svg";
import StudentChoiceContentForCompletionModal from "./StudentChoiceContentForCompletionModal";

type TCompletionModalProps = {
  documentSetListForStudentChoiceCases: TDocumentSetListForStudentChoiceCases;
  newCourseBuilder2Enabled: boolean;
  documentId?: number;
};

const CompletionModal = ({
  documentSetListForStudentChoiceCases,
  newCourseBuilder2Enabled,
  documentId,
}: TCompletionModalProps) => {
  const hasStudentChoiceCourses =
    newCourseBuilder2Enabled && (documentSetListForStudentChoiceCases?.length ?? 0) > 0;
  return (
    <div className="feedback-modal-background">
      <div className="completion-modal--container">
        <div className="completion-modal--content">
          <h2 className="completion-modal--content-title">Excellent work!</h2>
          <h3 className="completion-modal--content-subtitle">
            This case is now complete.
          </h3>
        </div>
        <div className="completion-modal--check-image--container">
          <img
            src={GreenCheckImage}
            alt="Green Check Mark"
            className="completion-modal--check-image-img"
          />
        </div>

        {hasStudentChoiceCourses ? (
          <>
            <p className="completion-modal--cta-text">
              Would you like to add this case to a course as a student-choice
              case? Select the course below:
            </p>

            <StudentChoiceContentForCompletionModal
              documentSetListForStudentChoiceCases={
                documentSetListForStudentChoiceCases
              }
              documentId={documentId}
            />
          </>
        ) : null}
      </div>
    </div>
  );
};

export default React.memo(CompletionModal);
